import { useQuery } from "@tanstack/react-query";
import { useApiClient } from "../clients/ApiClient";
import { Resource } from "../../core/models/wrappers/Resource";
import { CbsConfig } from "../../core/models/entities/CbsConfig";
import { CbsConfigDto } from "../models/responses/cbsConfigDto";

export interface CbsConfigRepository {
  useCbsConfig(): Resource<CbsConfig[]>;
}

function mapCbsConfig(dto: CbsConfigDto): CbsConfig {
  return {
    id: dto.id,
    methodKey: dto.methodKey,
    isColor: dto.isColor,
    colorKey: dto.colorKey,
    typeColors: (dto.typeColors ?? []).map((t) => ({
      isWhite: t.isWhite,
      mesh: t.mesh,
      stroke: t.stroke,
      key: t.key,
    })),
  };
}

export function useCbsConfigRepository(): CbsConfigRepository {
  const apiClient = useApiClient();

  function useCbsConfig(): Resource<CbsConfig[]> {
    return useQuery(
      ["cbsConfig"],
      async () => {
        const data = await apiClient.getCbsConfig();
        return data.map(mapCbsConfig);
      },
      { staleTime: 60 * 60 * 1000 },
    );
  }

  return { useCbsConfig };
}
